import { FETCH_RETAILERS } from "../actions/types";

export const retailersReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_RETAILERS:
      let retailers = action.payload;
      if (retailers.length > 1)
        retailers = retailers.sort((a, b) => {
          if (a.displayName.toLowerCase() > b.displayName.toLowerCase())
            return 1;
          if (b.displayName.toLowerCase() > a.displayName.toLowerCase())
            return -1;
          return 0;
        });
      return retailers;
    default:
      return state;
  }
};
